import {SERVICES} from '@/const';

const PREFIX_STATIC = `${SERVICES.STATIC_URL}/pubimg/`;
export const HOME_IMAGES = {
  BANNER_BG: PREFIX_STATIC + '79bbbcb5fe4a1439d9f4179c0f7695ee481e2bdbd3100a4093ec52b55dfc57fb.png',
  BANNER_BG_LOGIN: PREFIX_STATIC + '86b265e45ce2df57cc40fa4d4d9c661d425736f6e5f0d89ee71d622592ce863d.png',
  BANNER_GUEST: PREFIX_STATIC + '76f64187cc82b7fe31de5ad7e618d6c756640f31179a523ca15f57da9e96e07c.png',
  BANNER_LOGIN: PREFIX_STATIC + '2211416ec584e1aa9ff8db51ae2a3247c9ed4dde829718cb47d453f72349d067.png',
};

export const ADVANTAGE_IMAGES = {
  DEEP_LIQUIDITY: PREFIX_STATIC + '159841f89cc5250196f84aaf62590d823d56bdffa041418665145ce024bfe078.png',
  LOW_FEES: PREFIX_STATIC + '3d4796865179e9163dfe09b5c800b947813d6c24a3edfce023c3f4b78d0e933b.png',
  QUICK_SETTLEMENTS: PREFIX_STATIC + '7c3233ece2c1b513fb70b37ccfaf2be1d5b05d083efcb3aff419c9f78bc1f877.png',
};

export const OTCRRADINGWORK_IMAGES = {
  STEP_1: PREFIX_STATIC + '92a0269a22b2f38f7a0e787217de06453b84a2434b2c2205a9daae0d354d6e5b.png',
  STEP_2: PREFIX_STATIC + '6ae5843fae5ec260ea24d09737f06833b68531ecbd19bfc45c680b87f1d20c0b.png',
  STEP_3: PREFIX_STATIC + '6ce56297e16fcde22a3289890580ad4f91cd852378da05ff878a4a7871493a76.png',
  STEP_4: PREFIX_STATIC + '0620b24335436af82d589e5c752e0b05a1e1ccfe950bb0c92e8e06d69cb730e2.png',
};

export const SUPPORTEDDIGITALASSETS_IMAGES = {
  IMAGES: PREFIX_STATIC + '5ceb108705fb96586cd1951e6b447054bae2ac0d4486424fcf7a0720e3164cf5.png',
  MOBLILE_IMAGES: PREFIX_STATIC + '2a636516955be68aa39df9042317a0ede7dacd5c116372fba37bfb618ad865e7.png',
};
export const LEGENDTRADE_IMAGES = {
  CLOSE: PREFIX_STATIC + 'a189f044b63e48ca198f62c3a2e39e5d6909d5ea622dde7e5411ceee6d9ba9f4.png',
  POP_HEADER: PREFIX_STATIC + 'af797469e100c646d360f67a6a32b388f6c1294025923a5ee48fbd3a68e2211a.png',
};

export const CurrencyType = {
  Fiat: 'Fiat',
  Digital: 'Digital',
};

export const OtcKycStatus = {
  NoKyc: 70015, // BASIC_AND_ADVANCE_KYC_NOT_FINISHED
  NoRegionsNoAdvance: 70016, // BASIC_MISSING_ADVANCE_KYC_NOT_FINISHED
  NoAdvance: 70017, // ADVANCE_KYC_NOT_FINISHED
  NoBasic: 70018, // BASIC_KYC_NOT_FINISHED
  NoRegions: 70019, // BASIC_KYC_MISSING
  Processing: 70020, // BASIC_OR_ADVANCE_KYC_PROCESSING
  Unverified: 70021, // ADVANCE_KYC_UNVERIFIED
  NotSupport: 70022, // OTC_LEGEND_KYC_COUNTRY_NOT_SUPPORT
  TypeNotSupport: 70023, // PHEMEX.OTC.LEGEND.KYC.DOCUMENT.TYPE.NOT.SUPPORT
  Missing: 70024, // PHEMEX.OTC.LEGEND.KYC.MISSING.DOCUMENT
  AgainKyc: 100605, // PHEMEX.OTC.LEGEND.KYC.MISSING.DOCUMENT
  OnfidoAgain: 70074, // PHEMEX.OTC.LEGEND.KYC.MISSING.DOCUMENT
};

/** @type Record<ObjectValues<typeof OtcKycStatus>, keyof typeof OtcKycStatus>  */
export const OtcKycCode = Object.keys(OtcKycStatus).reduce(
  (obj, key) => ({
    ...obj,
    [OtcKycStatus[key]]: key,
  }),
  {}
);
